import { FormType, ReportJSON } from '@aloft/toolkit-shared';

import { create2DCompsArray } from '../utils.ts';
import { generateAdditionalCompsString } from './forms/additionalComps/index.ts';
import { generateFnma1004FormString } from './forms/fnma1004/index.ts';
import { generateFnma1004CFormString } from './forms/fnma1004c/index.ts';
import { generateFnma1025FormString } from './forms/fnma1025/index.ts';
import { generateFnma2055FormString } from './forms/fnma2055/index.ts';

type GenerateClickFormsTxtArgs = {
  compSequence: string[];
  reportJSON: ReportJSON;
  formType: FormType;
  isMerge: boolean;
};

export async function generateClickFormsTxt({
  compSequence,
  reportJSON,
  formType,
  isMerge,
}: GenerateClickFormsTxtArgs): Promise<string> {
  let resultString: string;
  const compSequence2dArray = create2DCompsArray(compSequence);
  switch (formType) {
    case FormType.fnma1004:
      resultString = generateFnma1004FormString(compSequence2dArray[0] ?? [], reportJSON, isMerge);
      break;
    case FormType.fnma2055:
      resultString = generateFnma2055FormString(compSequence2dArray[0] ?? [], reportJSON, isMerge);
      break;
    case FormType.fnma1004c:
      resultString = generateFnma1004CFormString(compSequence2dArray[0] ?? [], reportJSON, isMerge);
      break;
    case FormType.fnma1025:
      resultString = generateFnma1025FormString(compSequence2dArray[0] ?? [], reportJSON, isMerge);
      break;
    default:
      throw new Error(`Form Type ${formType} not yet supported`);
  }

  // Append Additional Comps Form
  if (compSequence2dArray.length > 1) {
    for (let i = 1; i < compSequence2dArray.length; i++) {
      const additionalComps = generateAdditionalCompsString(
        formType,
        compSequence2dArray[i] ?? [],
        reportJSON,
        isMerge,
        i,
      );
      resultString += additionalComps;
    }
  }

  return resultString;
}
